import { container } from '../container';

export interface CronNotificationRun {
    run_id: string;
    job_id: string;
    session_id?: string | null;
}

export interface CronUnreadNotificationSummary {
    total: number;
    latest_run: CronNotificationRun | null;
    session_ids: string[];
}

export class CronNotificationApi {
    static getUnreadSummary(baseURL: string): Promise<CronUnreadNotificationSummary> {
        // Cron Agent 的成功响应直接返回 summary，不使用 Eureka 的 data 包装层。
        return container.RnDHttp.get<CronUnreadNotificationSummary>({
            url: `${baseURL}/api/eureka/cronjobs/notifications/unread/summary`,
        });
    }
}
